import {
  GET_PROSPECT_REFERRAL_CODE,
  GET_SPAAZA_USER,
  GET_SPAAZA_WALLET,
  GET_SPAAZA_WALLET_HISTORY
} from '@/utils/store/actionTypes'
import { SET_SPAAZA_USER, SET_SPAAZA_WALLET } from '@/utils/store/mutationTypes'

import { apolloClient } from '@/utils/store'

import GetProspectReferralCode from '@/apollo/spaaza/GetProspectReferralCode.graphql'
import GetSpaazaUser from '@/apollo/spaaza/GetSpaazaUser.graphql'
import GetSpaazaHistory from '@/apollo/spaaza/GetSpaazaHistory.graphql'
import GetSpaazaWallet from '@/apollo/spaaza/GetSpaazaWallet.graphql'

export default {
  /**
   * Only if the current user has an active Spaaza account this will return
   * the referral code for the current user
   **/
  async [GET_PROSPECT_REFERRAL_CODE] (_, { prospectId }) {
    const { data } = await apolloClient(this).query({
      query: GetProspectReferralCode,
      variables: { prospectId }
    })

    return data.getSpaazaUser?.referralCode
  },

  /**
   * Gets current Spaaza user if user has active Spaaza account
   **/
  async [GET_SPAAZA_USER] ({ commit }) {
    let spaazaUser = null

    try {
      const { data } = await apolloClient(this).query({
        query: GetSpaazaUser
      })

      spaazaUser = data.getSpaazaUser
      if (spaazaUser) {
        commit(SET_SPAAZA_USER, spaazaUser)
      }
    } catch (e) { }

    return spaazaUser
  },

  /**
   * Gets current Spaaza users wallet balance
   **/
  async [GET_SPAAZA_WALLET] ({ commit }) {
    try {
      const { data } = await apolloClient(this).query({
        query: GetSpaazaWallet,
        fetchPolicy: 'no-cache'
      })

      if (data.getSpaazaWallet) {
        commit(SET_SPAAZA_WALLET, data.getSpaazaWallet)
      }

      return data.getSpaazaWallet
    } catch (e) {}

    return null
  },

  /**
   * Gets current Spaaza users wallet history
   **/
  async [GET_SPAAZA_WALLET_HISTORY] () {
    let entries = []
    try {
      const { data } = await apolloClient(this).query({
        query: GetSpaazaHistory,
        fetchPolicy: 'no-cache'
      })
      entries = data.getLoyaltyWalletHistoryEntries
    } catch (e) { }

    return entries.reduce((acc, contribution, index, array) => {
      const contributionWithIntegerAmount = { ...contribution, amount: parseFloat(contribution.amount) }
      const { campaignTitle = '' } = contributionWithIntegerAmount

      const lowerCaseCampaignTitle = campaignTitle.toLowerCase()

      const isInvitation = lowerCaseCampaignTitle.includes('refer a friend')
      const isLastContribution = array.length === index + 1 // Whenever someone got referred their first contribution won't be the spaaza create_account contribution. Instead they have the Refer a friend contribution as first. EVENTHOUGH they did not refer anyone. So threat this as if it's a Create Account campaign

      if (isInvitation && !isLastContribution) {
        acc.invitations.push(contributionWithIntegerAmount)
        acc.all.push(contributionWithIntegerAmount)
      } else if (isInvitation) {
        acc.contributions.push({ ...contributionWithIntegerAmount, campaignTitle: 'INT | Signup | Create account' })
        acc.all.push({ ...contributionWithIntegerAmount, campaignTitle: 'INT | Signup | Create account' })
      } else {
        acc.contributions.push(contributionWithIntegerAmount)
        acc.all.push(contributionWithIntegerAmount)
      }

      return acc
    }, {
      all: [],
      contributions: [],
      invitations: []
    })
  }
}
